import { component as defineComponent } from 'flightjs';

var button = function() {
    this.attributes({
        disabledAttr: 'data-button-disabled',
    });

    this.after('initialize', function() {
        this.on('click', this.handleClick);
    });

    this.handleClick = function(e, data) {
        if (this.node.hasAttribute(this.attr.disabledAttr)) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
    };
};

export default defineComponent(button);



// WEBPACK FOOTER //
// ./src/web/js/contest/ui/button.js